import React, { useState } from "react";
import { FileSpreadsheet, FileDown, Loader2 } from "lucide-react";
import { api } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const ExportButtons = ({ range, statusFilter, search, kategoriFilter }) => {
  const [busy, setBusy] = useState(null);

  const download = async (format) => {
    setBusy(format);
    try {
      const params = { format };
      if (range.start) params.start = range.start;
      if (range.end) params.end = range.end;
      if (statusFilter && statusFilter !== "ALL") params.status = statusFilter;
      if (kategoriFilter && kategoriFilter !== "ALL") params.kategori = kategoriFilter;
      if (search) params.q = search;
      const res = await api.get("/job-orders/export", { params, responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `rekap-jo-${new Date().toISOString().slice(0, 10)}.${format}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success(`Rekap ${format.toUpperCase()} berhasil diunduh`);
    } catch {
      toast.error("Gagal mengunduh rekap");
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="flex flex-wrap gap-3" data-testid="export-buttons">
      <Button
        data-testid="export-xlsx-btn"
        onClick={() => download("xlsx")}
        disabled={busy}
        className="h-10 rounded-xl bg-emerald-600/90 hover:bg-emerald-500 px-5 font-semibold"
      >
        {busy === "xlsx" ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : (
          <><FileSpreadsheet className="w-4 h-4 mr-2" /> Excel</>
        )}
      </Button>
      <Button
        data-testid="export-pdf-btn"
        onClick={() => download("pdf")}
        disabled={busy}
        className="h-10 rounded-xl bg-red-600/80 hover:bg-red-500 px-5 font-semibold"
      >
        {busy === "pdf" ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : (
          <><FileDown className="w-4 h-4 mr-2" /> PDF</>
        )}
      </Button>
    </div>
  );
};
